import * as api from '../api/eventform';
import { makeApiActionCreatorV3 } from '@actions/utils';

const namespace = 'EVENTS/EVENTFORM';

export const EVENT_FORMS_FETCH_START = `${namespace}/EVENT_FORMS_FETCH_START`;
export const EVENT_FORMS_FETCH_SUCCESS = `${namespace}/EVENT_FORMS_FETCH_SUCCESS`;
export const EVENT_FORMS_FETCH_ERROR = `${namespace}/EVENT_FORMS_FETCH_ERROR`;

export const ECONOMIC_UNITS_EVENT_FORMS_FETCH_START = `${namespace}/ECONOMIC_UNITS_EVENT_FORMS_FETCH_START`;
export const ECONOMIC_UNITS_EVENT_FORMS_FETCH_SUCCESS = `${namespace}/ECONOMIC_UNITS_EVENT_FORMS_FETCH_SUCCESS`;
export const ECONOMIC_UNITS_EVENT_FORMS_FETCH_ERROR = `${namespace}/ECONOMIC_UNITS_EVENT_FORMS_FETCH_ERROR`;

export const PROPERTY_EVENT_FORMS_FETCH_START = `${namespace}/PROPERTY_EVENT_FORMS_FETCH_START`;
export const PROPERTY_EVENT_FORMS_FETCH_SUCCESS = `${namespace}/PROPERTY_EVENT_FORMS_FETCH_SUCCESS`;
export const PROPERTY_EVENT_FORMS_FETCH_ERROR = `${namespace}/PROPERTY_EVENT_FORMS_FETCH_ERROR`;

export const OWNER_EVENT_FORMS_FETCH_START = `${namespace}/OWNER_EVENT_FORMS_FETCH_START`;
export const OWNER_EVENT_FORMS_FETCH_SUCCESS = `${namespace}/OWNER_EVENT_FORMS_FETCH_SUCCESS`;
export const OWNER_EVENT_FORMS_FETCH_ERROR = `${namespace}/OWNER_EVENT_FORMS_FETCH_ERROR`;

export const EVENT_FORM_CREATE_START = `${namespace}/EVENT_FORM_CREATE_START`;
export const EVENT_FORM_CREATE_SUCCESS = `${namespace}/EVENT_FORM_CREATE_SUCCESS`;
export const EVENT_FORM_CREATE_ERROR = `${namespace}/EVENT_FORM_CREATE_ERROR`;

export const EVENT_FORM_FETCH_START = `${namespace}/EVENT_FORM_FETCH_START`;
export const EVENT_FORM_FETCH_SUCCESS = `${namespace}/EVENT_FORM_FETCH_SUCCESS`;
export const EVENT_FORM_FETCH_ERROR = `${namespace}/EVENT_FORM_FETCH_ERROR`;

export const EVENT_FORM_UPDATE_START = `${namespace}/EVENT_FORM_UPDATE_START`;
export const EVENT_FORM_UPDATE_SUCCESS = `${namespace}/EVENT_FORM_UPDATE_SUCCESS`;
export const EVENT_FORM_UPDATE_ERROR = `${namespace}/EVENT_FORM_UPDATE_ERROR`;

export const EVENT_FORM_DELETE_START = `${namespace}/EVENT_FORM_DELETE_START`;
export const EVENT_FORM_DELETE_SUCCESS = `${namespace}/EVENT_FORM_DELETE_SUCCESS`;
export const EVENT_FORM_DELETE_ERROR = `${namespace}/EVENT_FORM_DELETE_ERROR`;

export const EVENT_FORM_CAN_DELETE_START = `${namespace}/EVENT_FORM_CAN_DELETE_START`;
export const EVENT_FORM_CAN_DELETE_SUCCESS = `${namespace}/EVENT_FORM_CAN_DELETE_SUCCESS`;
export const EVENT_FORM_CAN_DELETE_ERROR = `${namespace}/EVENT_FORM_CAN_DELETE_ERROR`;

export const DATA_OBJECTS_FETCH_START = `${namespace}/DATA_OBJECTS_FETCH_START`;
export const DATA_OBJECTS_FETCH_SUCCESS = `${namespace}/DATA_OBJECTS_FETCH_SUCCESS`;
export const DATA_OBJECTS_FETCH_ERROR = `${namespace}/DATA_OBJECTS_FETCH_ERROR`;

export const EVENT_GROUPS_FETCH_START = `${namespace}/EVENT_GROUPS_FETCH_START`;
export const EVENT_GROUPS_FETCH_SUCCESS = `${namespace}/EVENT_GROUPS_FETCH_SUCCESS`;
export const EVENT_GROUPS_FETCH_ERROR = `${namespace}/EVENT_GROUPS_FETCH_ERROR`;

export const EVENT_TYPES_UPDATE_START = `${namespace}/EVENT_TYPES_UPDATE_START`;
export const EVENT_TYPES_UPDATE_SUCCESS = `${namespace}/EVENT_TYPES_UPDATE_SUCCESS`;
export const EVENT_TYPES_UPDATE_ERROR = `${namespace}/EVENT_TYPES_UPDATE_ERROR`;

export const FORM_FIELDS_UPDATE_START = `${namespace}/FORM_FIELDS_UPDATE_START`;
export const FORM_FIELDS_UPDATE_SUCCESS = `${namespace}/FORM_FIELDS_UPDATE_SUCCESS`;
export const FORM_FIELDS_UPDATE_ERROR = `${namespace}/FORM_FIELDS_UPDATE_ERROR`;

export const EVENT_FORM_DUPLICATE_START = `${namespace}/EVENT_FORM_DUPLICATE_START`;
export const EVENT_FORM_DUPLICATE_SUCCESS = `${namespace}/EVENT_FORM_DUPLICATE_SUCCESS`;
export const EVENT_FORM_DUPLICATE_ERROR = `${namespace}/EVENT_FORM_DUPLICATE_ERROR`;

export const FORM_TAGS_FETCH_START = `${namespace}/FORM_TAGS_FETCH_START`;
export const FORM_TAGS_FETCH_SUCCESS = `${namespace}/FORM_TAGS_FETCH_SUCCESS`;
export const FORM_TAGS_FETCH_ERROR = `${namespace}/FORM_TAGS_FETCH_ERROR`;

export const FETCH_FORM_PUBLISHED_TYPES_START = `${namespace}/FETCH_FORM_PUBLISHED_TYPES_START`;
export const FETCH_FORM_PUBLISHED_TYPES_SUCCESS = `${namespace}/FETCH_FORM_PUBLISHED_TYPES_SUCCESS`;
export const FETCH_FORM_PUBLISHED_TYPES_ERROR = `${namespace}/FETCH_FORM_PUBLISHED_TYPES_ERROR`;

export const FETCH_FORM_UNPUBLISHED_TYPES_START = `${namespace}/FETCH_FORM_UNPUBLISHED_TYPES_START`;
export const FETCH_FORM_UNPUBLISHED_TYPES_SUCCESS = `${namespace}/FETCH_FORM_UNPUBLISHED_TYPES_SUCCESS`;
export const FETCH_FORM_UNPUBLISHED_TYPES_ERROR = `${namespace}/FETCH_FORM_UNPUBLISHED_TYPES_ERROR`;

export const PUBLISH_FORM_UNPUBLISHED_TYPES_START = `${namespace}/PUBLISH_FORM_UNPUBLISHED_TYPES_START`;
export const PUBLISH_FORM_UNPUBLISHED_TYPES_SUCCESS = `${namespace}/PUBLISH_FORM_UNPUBLISHED_TYPES_SUCCESS`;
export const PUBLISH_FORM_UNPUBLISHED_TYPES_ERROR = `${namespace}/PUBLISH_FORM_UNPUBLISHED_TYPES_ERROR`;

export const DELETE_FORM_PUBLISHED_TYPE_START = `${namespace}/DELETE_FORM_PUBLISHED_TYPE_START`;
export const DELETE_FORM_PUBLISHED_TYPE_SUCCESS = `${namespace}/DELETE_FORM_PUBLISHED_TYPE_SUCCESS`;
export const DELETE_FORM_PUBLISHED_TYPE_ERROR = `${namespace}/DELETE_FORM_PUBLISHED_TYPE_ERROR`;

export const RESET_EVENT_FORM = `${namespace}/RESET_EVENT_FORM`;

export const fetchEventForms = makeApiActionCreatorV3(
  api.fetchEventForms,
  EVENT_FORMS_FETCH_START,
  EVENT_FORMS_FETCH_SUCCESS,
  EVENT_FORMS_FETCH_ERROR,
);

export const fetchEconomicUnitEventForms = makeApiActionCreatorV3(
  api.fetchEconomicUnitEventForms,
  ECONOMIC_UNITS_EVENT_FORMS_FETCH_START,
  ECONOMIC_UNITS_EVENT_FORMS_FETCH_SUCCESS,
  ECONOMIC_UNITS_EVENT_FORMS_FETCH_ERROR,
);

export const fetchPropertyEventForms = makeApiActionCreatorV3(
  api.fetchPropertyEventForms,
  PROPERTY_EVENT_FORMS_FETCH_START,
  PROPERTY_EVENT_FORMS_FETCH_SUCCESS,
  PROPERTY_EVENT_FORMS_FETCH_ERROR,
);

export const fetchEventFormsByType = makeApiActionCreatorV3(
  api.fetchEventFormsByType,
  OWNER_EVENT_FORMS_FETCH_START,
  OWNER_EVENT_FORMS_FETCH_SUCCESS,
  OWNER_EVENT_FORMS_FETCH_ERROR,
);

export const createEventForm = makeApiActionCreatorV3(
  api.createEventForm,
  EVENT_FORM_CREATE_START,
  EVENT_FORM_CREATE_SUCCESS,
  EVENT_FORM_CREATE_ERROR,
);

export const fetchEventForm = makeApiActionCreatorV3(
  api.fetchEventForm,
  EVENT_FORM_FETCH_START,
  EVENT_FORM_FETCH_SUCCESS,
  EVENT_FORM_FETCH_ERROR,
);

export const updateEventForm = makeApiActionCreatorV3(
  api.updateEventForm,
  EVENT_FORM_UPDATE_START,
  EVENT_FORM_UPDATE_SUCCESS,
  EVENT_FORM_UPDATE_ERROR,
);

export const deleteEventForm = makeApiActionCreatorV3(
  api.deleteEventForm,
  EVENT_FORM_DELETE_START,
  EVENT_FORM_DELETE_SUCCESS,
  EVENT_FORM_DELETE_ERROR,
);

export const canDeleteEventForm = makeApiActionCreatorV3(
  api.canDeleteEventForm,
  EVENT_FORM_CAN_DELETE_START,
  EVENT_FORM_CAN_DELETE_SUCCESS,
  EVENT_FORM_CAN_DELETE_ERROR,
);

export const fetchDataObjects = makeApiActionCreatorV3(
  api.fetchDataObjects,
  DATA_OBJECTS_FETCH_START,
  DATA_OBJECTS_FETCH_SUCCESS,
  DATA_OBJECTS_FETCH_ERROR,
);

export const fetchEventGroups = makeApiActionCreatorV3(
  api.fetchEventGroups,
  EVENT_GROUPS_FETCH_START,
  EVENT_GROUPS_FETCH_SUCCESS,
  EVENT_GROUPS_FETCH_ERROR,
);

export const updateEventTypes = makeApiActionCreatorV3(
  api.updateEventTypes,
  EVENT_TYPES_UPDATE_START,
  EVENT_TYPES_UPDATE_SUCCESS,
  EVENT_TYPES_UPDATE_ERROR,
);

export const updateFormFields = makeApiActionCreatorV3(
  api.updateFormFields,
  FORM_FIELDS_UPDATE_START,
  FORM_FIELDS_UPDATE_SUCCESS,
  FORM_FIELDS_UPDATE_ERROR,
);

export const fetchFormTags = makeApiActionCreatorV3(
  api.fetchFormTags,
  FORM_TAGS_FETCH_START,
  FORM_TAGS_FETCH_SUCCESS,
  FORM_TAGS_FETCH_ERROR,
);

export const duplicateEventForm = makeApiActionCreatorV3(
  api.duplicateEventForm,
  EVENT_FORM_DUPLICATE_START,
  EVENT_FORM_DUPLICATE_SUCCESS,
  EVENT_FORM_DUPLICATE_ERROR,
);

export function resetEventForm() {
  return async dispatch => {
    dispatch({ type: RESET_EVENT_FORM });
  };
}

export const fetchEventFormPublishedTypes = makeApiActionCreatorV3(
  api.fetchEventFormPublishedTypes,
  FETCH_FORM_PUBLISHED_TYPES_START,
  FETCH_FORM_PUBLISHED_TYPES_SUCCESS,
  FETCH_FORM_PUBLISHED_TYPES_ERROR,
);

export const fetchEventFormUnPublishedTypes = makeApiActionCreatorV3(
  api.fetchEventFormUnPublishedTypes,
  FETCH_FORM_UNPUBLISHED_TYPES_START,
  FETCH_FORM_UNPUBLISHED_TYPES_SUCCESS,
  FETCH_FORM_UNPUBLISHED_TYPES_ERROR,
);

export const publishEventFormUnPublishedTypes = makeApiActionCreatorV3(
  api.publishEventFormUnPublishedTypes,
  PUBLISH_FORM_UNPUBLISHED_TYPES_START,
  PUBLISH_FORM_UNPUBLISHED_TYPES_SUCCESS,
  PUBLISH_FORM_UNPUBLISHED_TYPES_ERROR,
);

export const deleteEventFormPublishedType = makeApiActionCreatorV3(
  api.deleteEventFormPublishedType,
  DELETE_FORM_PUBLISHED_TYPE_START,
  DELETE_FORM_PUBLISHED_TYPE_SUCCESS,
  DELETE_FORM_PUBLISHED_TYPE_ERROR,
);
